import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactSwipe from 'react-swipe';
import classes from './Tips.style.module.scss';

class Tips extends Component {
  static propTypes = {
    idType: PropTypes.string,
    step: PropTypes.number,
    onCapture: PropTypes.func.isRequired,
    display: PropTypes.string,
    tips: PropTypes.object
  };

  static defaultProps = {
    idType: 'AUS_AUTO_DRIVERLICENCE',
    step: 0,
    tips: []
  };

  constructor(props) {
    super(props);

    this.state = {
      step: 0
    };

    this.isComponentMounted = false;
    this.reactSwipe = null;

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.isComponentMounted = true;
  }

  // eslint-disable-next-line camelcase
  async UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log(' nextProps.step',  nextProps.step)
    this.setState({
      step: nextProps.step
    });

    /* if(nextProps.idType !== this.state.idType){

        } */

    const { idType } = nextProps;

    let path = `images/tips/AUVOI_FLOW`;
    let shortPath = '';

    if (idType.includes('DRIVERLICENCE')) {
      path = `${path}/DL`;
      shortPath = 'DL';
    } else if (idType === 'PASSPORT') {
      path = `${path}/PASSPORT`;
      shortPath = 'PASSPORT';
    } else if (idType === 'AUS_MEDICARE') {
      path = `${path}/AUS_MEDICARE`;
      shortPath = 'AUS_MEDICARE';
    } else if (idType === 'AUS_AUTO_BIRTH') {
      path = `${path}/AUS_AUTO_BIRTH`;
      shortPath = 'AUS_AUTO_BIRTH';
    } else if (idType === 'AUS_AUTO_NAME') {
      path = `${path}/AUS_AUTO_NAME`;
      shortPath = 'AUS_AUTO_NAME';
    } else if (idType === 'AUS_AUTO_MARRIAGE') {
      path = `${path}/AUS_AUTO_MARRIAGE`;
      shortPath = 'AUS_AUTO_MARRIAGE';
    }

    this.setState({
      path,
      shortPath
    });
  }

  componentWillUnmount() {
    this.isComponentMounted = false;
  }

  /**
   * Handle the next button
   * @return {Void}
   */
  handleClick() {
    const { step } = this.state;
    const { tips, onCapture } = this.props;

    if (step < tips.length - 1) {
      this.reactSwipe.next();
    } else {
      onCapture();
    }
  }

  render() {
    const { tips, display } = this.props;

    const { step } = this.state;
    let { path = 'images/tips/AUVOI_FLOW/DL/', shortPath = 'DL' } = this.state;

    if (Object.keys(tips).includes('AUS_AUTO_NAME')) {
      path = 'images/tips/AUVOI_FLOW/AUS_AUTO_NAME/';
      shortPath = 'AUS_AUTO_NAME';
    }

    const swipeOptions = {
      continuous: false,
      callback: (stepValue) => {
        if (this.isComponentMounted) {
          this.setState({ step: stepValue });
        }
      }
    };

    const nTips = tips[shortPath] || [];
    const title = nTips.length > 0 ? tips[shortPath][step] : '';

    const imgs = nTips.map((tip, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <div key={i} style={{ textAlign: 'center' }}>
        <img alt="" src={`${path}/tip-${i + 1}.png`} />
      </div>
    ));
    const Dots = () => {
      // eslint-disable-next-line react/no-array-index-key
      return nTips.map((tip, i) => <li key={i} className={i === step ? classes.active : ''} />);
    };

    return (
      <div className={classNames(classes.wrapper, display)}>
        <ReactSwipe
          className={classes.swContainer}
          swipeOptions={swipeOptions}
          ref={(ref) => {
            this.reactSwipe = ref;
          }}
        >
          {imgs}
        </ReactSwipe>
        <div className="wp-b-tipsHeader">
          <h3>{title}</h3>
        </div>
        <ul className={classes.dots}>
          <Dots />
        </ul>
        {/* <Button onClick={this.handleClick} shadow large full label={buttonText} /> */}
      </div>
    );
  }
}

export default Tips;
